var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscudo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.044 3.7667L16 1.33203L26.956 3.7667C27.2521 3.83252 27.5169 3.99732 27.7067 4.2339C27.8965 4.47049 27.9999 4.76472 28 5.06803V18.384C27.9999 19.701 27.6747 20.9976 27.0532 22.1587C26.4317 23.3198 25.5332 24.3095 24.4373 25.04L16 30.6654L7.56267 25.04C6.46703 24.3097 5.56861 23.3202 4.94713 22.1593C4.32565 20.9984 4.00032 19.7021 4 18.3854V5.06803C4.00005 4.76472 4.10352 4.47049 4.29332 4.2339C4.48312 3.99732 4.74792 3.83252 5.044 3.7667ZM6.66667 6.13736V18.384C6.66668 19.262 6.88343 20.1263 7.29768 20.9004C7.71193 21.6745 8.31087 22.3343 9.04133 22.8214L16 27.4614L22.9587 22.8214C23.6889 22.3344 24.2878 21.6748 24.702 20.901C25.1162 20.1272 25.3331 19.2631 25.3333 18.3854V6.13736L16 4.06536L6.66667 6.13736ZM14.6667 13.332V9.33203H17.3333V13.332H21.3333V15.9987H17.3333V19.9987H14.6667V15.9987H10.6667V13.332H14.6667Z",
    fill: "#E2B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudo);
export default __webpack_public_path__ + "static/media/escudo.9f9fecb0c40efca6dd94883f179a2d34.svg";
export { ForwardRef as ReactComponent };